import { render } from "./WhatsHappening.vue?vue&type=template&id=fd3d88ce"
import script from "./WhatsHappening.vue?vue&type=script&lang=js"
export * from "./WhatsHappening.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__